module.exports = __webpack_public_path__ + "img/index-comp-pic3.432712d9.png";